import { applyMiddleware, createStore, Store, compose } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import { CookieStorage } from 'redux-persist-cookie-storage';
import Cookies from 'js-cookie';
import reducers, { RootState } from 'client/_redux/reducers';
import { thunk } from 'redux-thunk';

const persistConfig = {
  key: 'root',
  whitelist: ['auth'], // Synchronisé avec le serveur - seul 'auth' est persisté
  storage: new CookieStorage(Cookies, {
    expiration: {
      default: 365 * 86400, // Cookies expire after one year
    },
  }),
};

const rootReducer = persistReducer<RootState>(persistConfig, reducers);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createReduxPersistor = (store: Store, cb?: () => any) =>
  persistStore(store, {}, cb);

const configureStore = (preloadedState: RootState | Record<string, unknown> = {}) => {
  const middleware = applyMiddleware(thunk);
  
  // Use Redux DevTools Extension if available
  const composeEnhancers =
    (typeof window !== 'undefined' &&
      (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

  return createStore(rootReducer, preloadedState, composeEnhancers(middleware));
};

export default configureStore;
